import { useContext } from 'react';
import { FormikContext, useField } from 'formik';

const useFormInput = props => {
	const defaultProps =
		!!props && Object.keys(props).length > 0
			? props
			: {
					field: null,
					meta: null,
					onChange: null,
					setValue: null,
					value: null,
			  };

	let { field, meta, onChange, setValue } = defaultProps;
	let value = defaultProps.value;
	try {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const [_field, _meta, _helpers] = useField(props);
		field = _field;
		meta = _meta;
		setValue = _helpers.setValue;
		value = !!field && field.value !== null ? field.value : null;
	} catch {}

	// 'validate' property should not be forwarded to native controls
	const { validate: _, ...rest } = props;

	return {
		field: field,
		meta: meta,
		onChange: onChange,
		setValue: setValue,
		value: value,
		additionalProps: rest,
	};
};

export default useFormInput;
